import { QueryConstraint, Unsubscribe, limit, where } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";
import randomString from "../../helpers/utils/functions/randomString";
import Monitor from "../entities/pdv/monitor.entity";
class MonitorsDB extends FirestorePipe {

  public static readonly colName = 'Monitors'
  private idStore: string;
  constructor(idEstab: string, idStore: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    if(!idStore)
      throw new Error('Informe o id da loja')
    super(`${EstablishmentDB.colName}/${idEstab}/${MonitorsDB.colName}`);
    this.idStore = idStore;
  }

  public async create(data: Monitor): Promise<any> {
    const key = await this.generateKey();
    return this._create({
      ...data,
      key,
      storeId: this.idStore
    });
  }
  public update(id: string, data: Monitor): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<Monitor[]> {
    return this._getAll<Monitor>(...params);
  }
  public get(id: string): Promise<Monitor> {
    return this._get(id);
  }
  public on(listener: (data: Monitor[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, where('storeId', '==', this.idStore), ...params);
  }

  private async generateKey() {
    let key;
    let totens;
    do {
      key = randomString(8);
      totens = await this.getAll(
        where('key', '==', key),
        limit(1)
      )
    } while(totens.length !== 0);
    return key;
  }
}

export default MonitorsDB;